import ThemeOptions from './themeOptions';
import Admin from './admin';

export default {
  Admin,
  ThemeOptions
};
